import "./Navbar.css";
import React, { useEffect, useState } from "react";
import { FaBars } from "react-icons/fa";
import { FaTimes } from "react-icons/fa";

const Navbar = () => {
   const [isActive, setIsActive] = useState(false);
   const [activeBtn, setActiveBtn] = useState(false);

   const clickHandler = () => {
      setIsActive(!isActive);
      setActiveBtn(!activeBtn);
      console.log("clicked");
      console.log(isActive);
      console.log(activeBtn);
   }

   useEffect(() => {
      const handleScroll = () => {
        setActiveBtn(false);
        setIsActive(false)

      }
      window.addEventListener('scroll', handleScroll);

   }, [])


   return (<div>
      <div className={`navbar ${isActive ? 'active' : ''}`}>
         <div>

            {
               activeBtn ? (<FaTimes onClick={clickHandler} className=" close " size={"200px"} />) : (<FaBars onClick={clickHandler} className="menu" size={"200px"} />)
            }
         </div>
         <div className="size">Portfolio</div>
         <div className="fake"></div>
         <ul className="">

            <li><a href="#main1">Home</a></li>
            <li><a href="#biography1">About</a></li>
            <li><a href="#skill1">Skills</a></li>
            <li><a href="#education1">Education</a></li>
            <li><a href="#projects">Portfolio</a></li>
            <li><a href="#contact1">Contact me</a></li>
         </ul>
      </div>
   </div>)
}
export default Navbar;